module.exports = __webpack_public_path__ + "img/teams_no_folder_content.a1a4a7c4.svg";